import React from "react";
import clsx from "clsx";

export function Card({ className, children, ...props }) {
  return (
    <div className={clsx("glass-card rounded-2xl", className)} {...props}>
      {children}
    </div>
  );
}

export function Badge({ status, children, className, ...props }) {
  const styles = {
    active: "border-emerald-400/40 text-emerald-300 shadow-[0_0_16px_-2px_rgba(16,185,129,0.5)]",
    pending: "border-amber-400/40 text-amber-300 shadow-[0_0_16px_-2px_rgba(245,158,11,0.5)]",
    inactive: "border-slate-500/40 text-slate-400",
    failed: "border-red-400/40 text-red-300",
    used: "border-slate-500/40 text-slate-400",
    unused: "border-emerald-400/40 text-emerald-300",
    disabled: "border-red-400/40 text-red-300",
    paused: "border-red-500/60 text-red-300 bg-red-500/10 shadow-[0_0_16px_-2px_rgba(239,68,68,0.6)] animate-pulse",
  };
  return (
    <span {...props} className={clsx(
      "inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider border bg-white/[0.02]",
      styles[status] || styles.inactive, className
    )}>
      {children}
    </span>
  );
}

export function Switch({ checked, onChange, testId, disabled }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={clsx(
        "relative w-11 h-6 rounded-full transition-colors duration-200 disabled:opacity-40",
        checked ? "bg-primary shadow-ambient" : "bg-white/10 border border-white/15"
      )}
    >
      <span
        className={clsx(
          "absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform duration-200",
          checked && "translate-x-5"
        )}
      />
    </button>
  );
}
